import { Graphics, Text } from "pixi.js";
import DisplayContainer from "../components/DisplayContainer";
import AppModel from "../models/AppModel";
import SoundManager from "../managers/SoundManager";

export default class Complete extends DisplayContainer {
    private model: AppModel;
    private bg: Graphics;
    private soundManager: SoundManager;

    constructor() {
        super();
        this._init();
    }

    private _init() {
        this.label = "Complete";
        this.model = AppModel.getInstance();
        this.soundManager = SoundManager.getInstance();
        this.create();
    }

    private createBackground() {
        this.bg = new Graphics();
        this.bg.fill(0xFFFFFF);//.fill(0x3498db);
        this.bg.rect(0, 0, this.model.stageWidth, this.model.stageHeight);
        this.bg.fill();
        this.addChild(this.bg);
    }

    private createText() {
        const text = new Text({
            label: "Complete Text",
            text: "Complete!",
            style: {
                fontSize: 62,
                fill: "#061054",
                align: "center"
            },
        });
        text.x = this.model.centerX - text.width / 2;
        text.y = this.model.centerY - text.height / 2;
        this.addChild(text);
    }

    private playAudio() {
        this.soundManager.playSound(`/assets/audio/158.mp3`);
    }


    public override create(showAfterCreate: boolean = true): void {
        this.createBackground();

        this.createText();
        this.playAudio();

        if (showAfterCreate) {
            this.show();
        }
    }

    public override destroy(): void {
        super.destroy();
    }
}